/* eslint-disable class-methods-use-this */

class FincTableSortAndOrder {
  constructor({
    rootEl,
    // item,
  } = {}) {
    this.rootEl = rootEl;
    // this.item = item;
    this.sortByValue = null;
    this.thIndex = null;
    this.filterValue = null;

    this.tableEl = rootEl.querySelector('.fincchta-table');
    this.tbodyEl = this.tableEl.querySelector('tbody');
    this.rows = this.tbodyEl.querySelectorAll('tr');

    this.init();
  }

  changeActionSort(event) {
    this.sortByValue = event.target.value;
    this.sortAndFilter();
  }

  sortAndFilter() {
    // filter
    let table = [...this.rows];
    table = this.filterTable(table);
    // sort what is left
    table = this.orderTable(table);
    this.populateTable(table);
  }

  getValue(el) {
    return el.querySelectorAll('td')[this.thIndex].getAttribute(`data-${this.sortByValue}`);
  }

  sortTable(table) {
    const newArr = Array.from(table).sort((a, b) => {
      if (this.sortByValue === 'date') {
        // numeric sort
        return this.getValue(b) - this.getValue(a);
      }
      // string sort
      return this.getValue(a).localeCompare(this.getValue(b), 'fi', { sensitivity: 'base' });
    });
    return newArr;
  }

  populateTable(sortedRows) {
    // empty list first
    this.removeAllChildNodes(this.tbodyEl);
    // then populate
    sortedRows.forEach((row) => {
      this.tbodyEl.append(row);
    });
  }

  changeActionFilter(event) {
    this.filterValue = event.target.value;
    this.sortAndFilter();
  }

  filterTable(table) {
    if (!this.filterValue) {
      return table;
    }
    return Array.from(table).filter((row) => row.getAttribute('data-type') === this.filterValue);
  }

  orderTable(table) {
    if (table.length < 1) {
      return table;
    }
    // do not sort if no value
    if (!this.sortByValue) {
      return table;
    }
    // get index of the table header
    [...this.tableEl.querySelectorAll('th')].forEach((element, index) => {
      const attr = element.getAttribute('data-name');
      if (attr === this.sortByValue) {
        this.thIndex = index;
      }
    });

    return this.sortTable(table);
  }

  removeAllChildNodes(parent) {
    while (parent.firstChild) {
      parent.removeChild(parent.firstChild);
    }
  }

  init() {
    const orderTables = this.rootEl.querySelectorAll('.fincchta-table-order__select');
    const filterTables = this.rootEl.querySelectorAll('.fincchta-table-filter__select');
    [...orderTables].map((item) => item.addEventListener('change', (e) => { this.changeActionSort(e); }));
    [...filterTables].map((item) => item.addEventListener('change', (e) => { this.changeActionFilter(e); }));
  }
}

export default FincTableSortAndOrder;
